import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './Statistic.css'; // css-модуль

// Импорты из вашего проекта — поправь пути при необходимости
import { getTechnics, getOrders } from './statisticApi';
import { selectLanguage, selectRole, selectUserId } from '../Login/loginSlice';
import {
  setAudios,
  setColor,
  setComments,
  setOrder,
  setPacient,
  setPaid,
  setPhotos,
  setPrice,
  setShowOrderCard,
  setTechnicId,
} from '../Lab/Orders/orderSlice';

import { setShowDoctorOrders } from '../Lab/labSlice';
import { useNavigate } from 'react-router-dom';
import { texts } from '../Common/common';
import { getOrderAudios, getOrderComments, getOrderPhotos } from '../Lab/Orders/orderApi';

export const Statistic = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const role = useSelector(selectRole);
  const user_id = useSelector(selectUserId);
  const currentLanguage = useSelector(selectLanguage);

  const [selectedTechnicIndex, setSelectedTechnicIndex] = useState(0);
  const [technics, setTechnics] = useState([]);
  const [technicsFilter, setTechnicsFilter] = useState([]);
  const [orders, setOrders] = useState([]);

  const [dateStart, setDateStart] = useState(() => {
    const now = new Date();
    return now.toISOString().slice(0, 10); // YYYY-MM-DD
  });
  const [dateEnd, setDateEnd] = useState(() => {
    const now = new Date();
    return now.toISOString().slice(0, 10);
  });

  // Наведение порядка в данных: при клике на заказ воспроизводим поведение моб.версии
  function handlePressOrder(order) {
    dispatch(setOrder(order));
    dispatch(setPacient(order.pacient));
    dispatch(setPaid(order.paid));
    dispatch(setTechnicId(order.technic_id));
    dispatch(setPrice(order.price));
    dispatch(setColor(order.color));

    getOrderPhotos({ order_id: order.id }, (data) => {
      dispatch(setPhotos(data.photos || []));
    });

    getOrderAudios({ order_id: order.id }, (data) => {
      dispatch(setAudios(data.audios || []));
    });

    getOrderComments({ order_id: order.id }, (data) => {
      dispatch(setComments(data.comments || []));
    });

    dispatch(setShowDoctorOrders(true));
    dispatch(setShowOrderCard(true));
  }

  // Вспомог: получить заказы с бэкенда по current dateStart/dateEnd/user_id
  const fetchOrders = (opts = {}) => {
    console.log('fetchOrders', user_id)
    const params = {
      user_id: user_id,
      date_start: opts.date_start ?? dateStart + ' 00:00:00',
      date_end: opts.date_end ?? dateEnd + ' 23:59:59',
    };
    getOrders(params, (data) => {
        console.log('data fetchOrders', data)
      setOrders(data.orders || []);
    });
  };

  useEffect(() => {
    if (role === 'doctor') return;
    fetchOrders({ date_start: dateStart + ' 00:00:00', date_end: dateEnd + ' 23:59:59' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (role === 'doctor') return;
    getTechnics({ user_id }, (data) => {
      const technicsObj = data.technics || [];
      setTechnics(technicsObj);
      // Формируем список для селекта: Все / Имя Фамилия
      const filter = ['Все', ...Object.keys(technicsObj).map((i) => `${technicsObj[i].name} ${technicsObj[i].surname}`)];
      setTechnicsFilter(filter);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // пересчет комиссии как в моб.версии
  const totalSelectedTechnicPrice = useMemo(() => {
    const selectedTechnic = technics[selectedTechnicIndex - 1];
    return orders
      .filter((order) => (selectedTechnic ? order.technic_id === selectedTechnic.id : true) || selectedTechnicIndex === 0)
      .reduce((acc, order) => acc + (order.price * ((order.commission || 0) / 100) || 0), 0);
  }, [orders, technics, selectedTechnicIndex]);

  const commission = totalSelectedTechnicPrice;

  // Обработчики дат (input[type="date"] возвращает YYYY-MM-DD)
  const onChangeDateStart = (e) => {
    const newDate = e.target.value;
    setDateStart(newDate);
    fetchOrders({ date_start: newDate + ' 00:00:00', date_end: dateEnd + ' 23:59:59' });
  };

  const onChangeDateEnd = (e) => {
    const newDate = e.target.value;
    setDateEnd(newDate);
    fetchOrders({ date_start: dateStart + ' 00:00:00', date_end: newDate + ' 23:59:59' });
  };

  return (
    <div className="container" style={role === 'doctor' ? { display: 'none' } : undefined}>
      <div className="header">
        <h2 className="headerTitle">{texts[currentLanguage].orders}</h2>
      </div>

      {/* Фильтр */}
      <div className="filterBox">
        <div className="filterLabel">{texts[currentLanguage].filters}</div>

        <div className="filterRow">
          <label className="label">{texts[currentLanguage].technician}</label>
          <div className="inputWrapper">
            <select
              className="select"
              value={selectedTechnicIndex}
              onChange={(e) => setSelectedTechnicIndex(Number(e.target.value))}
            >
              {technicsFilter.map((t, idx) => (
                <option key={idx} value={idx}>
                  {t}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="filterRow">
          <label className="label">{texts[currentLanguage].period}</label>
          <div className="dateGroup">
            <input type="date" className="dateInput" value={dateStart} onChange={onChangeDateStart} />
            <div className="divider" />
            <input type="date" className="dateInput" value={dateEnd} onChange={onChangeDateEnd} />
          </div>
        </div>
      </div>

      {/* Зарплата */}
      <div className="headBlock">
        <div className="headLabel">{texts[currentLanguage].salary}</div>
        <div className="salaryRow">
          <div className="salaryText">
            {technics[selectedTechnicIndex - 1]?.commission}% - {commission} руб
          </div>
        </div>
      </div>

      {/* Список заказов */}
      <div className="listContainer">
        <div className="scrollList">
          {orders.map((order, index) => {
            const visible =
              selectedTechnicIndex === 0 || order.technic_id === technics[selectedTechnicIndex - 1]?.id;
            if (!visible) return null;
            return (
              <div
                key={index}
                className="orderItem"
                onClick={() => {
                  handlePressOrder(order);
                  // Навигация — как в мобильной версии (подправь имя маршрута)
                  navigate('/lab', { state: { orderId: order.id } });
                }}
                role="button"
                tabIndex={0}
                onKeyDown={() => {}}
              >
                <div className="rowBetween">
                  <span>№{order.number || order.id}</span>
                  <span className="grayText">{(order.date || '').slice(0, 10)}</span>
                </div>

                <div className="rowBetween">
                  <span>
                    {texts[currentLanguage].patientLabel}: {order.patient_name}
                  </span>
                  <span className="grayText">
                    {texts[currentLanguage].doctor}: {order.doctor_name}
                  </span>
                </div>

                <div className="rowBetween">
                  <span>
                    {texts[currentLanguage].priceLabel}: {order.price}
                  </span>
                  <span className="grayText">
                    {texts[currentLanguage].paid}: {order.paid}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Statistic;
